import React from 'react';
import {withRouter} from 'react-router-dom';
import {DefaultButton, Stack} from '@fluentui/react';

const AboutPage = (props) => {

    const btnHome_Click = () => {
        props.history.push("/");
    }

    return (
        <Stack horizontalAlign="center">
            <h1>درباره ما...</h1>
            <DefaultButton text="صفحه اصلی" onClick={btnHome_Click} iconProps={{ iconName: "Home" }}/>
        </Stack>
    )
}

export default withRouter(AboutPage);